// extracted by mini-css-extract-plugin
export var animationContainer = "_ea-0";
export var asteriskIcon = "_ea-8";
export var conversationLeftSection = "_ea-4";
export var conversationListItem = "_ea-3";
export var conversationMiddleSection = "_ea-5";
export var conversationRightSection = "_ea-6";
export var detailsContent = "_ea-1";
export var listContainer = "_ea-7";
export var modalContent = "_ea-2";